export default "__VITE_ASSET__DDsbNEpX__"